import { type IndexedDBConnector } from '@/types/accessor/common/connector'
import * as indexedDB from './common/indexedDBController'
import { handleError } from '../util/errorHandler'
import type { ResQueryGovernmentSettings } from '@/types/accessor/api/governmentSetting/governmentSetting'
import { METHOD, SEND_STATE } from '@/constants/accessor/indexedDB/indexedDB'

const STORE_NAME = 'government_setting'
const IDB_ERROR_CODE = 'idb_02'

/**
 * 共通エラーレスポンス
 */
export interface GovernmentSettingApiErrorResponse {
  error: string
}

/**
 * getのリクエストパラメータ
 */
export interface GetGovernmentSettingParams {
  system: string
  govCode: string
}

/**
 * IndexedDBにデータを挿入する
 * @param data 挿入するデータ
 * @returns なし
 */
export const set: IndexedDBConnector<ResQueryGovernmentSettings, undefined, void> = async (
  data?: ResQueryGovernmentSettings
): Promise<void> => {
  if (!data) {
    console.error('Data is undefined')
    return
  }
  await indexedDB
    .set(STORE_NAME, data, METHOD.GET, SEND_STATE.FETCHED, data.govCode)
    .catch(async () => await handleError(IDB_ERROR_CODE))
}

/**
 * 指定されたキー情報に基づくデータをIndexedDBから取得する
 * @param params データ取得用のキー情報
 * @returns 取得したデータ
 */
export const get: IndexedDBConnector<GetGovernmentSettingParams, undefined, unknown> = async (
  params?: GetGovernmentSettingParams
): Promise<unknown> => {
  if (!params) {
    console.error('Data is undefined')
    return
  }
  return await indexedDB.get(STORE_NAME, params.govCode).catch(async () => {
    await handleError(IDB_ERROR_CODE)
  })
}
